export default "__VITE_ASSET__qe$FULw6__"